<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash" @exps="exp" @search="search" @del="delall" ref="SetBtn"></buttonlist>
		<serce :isVisible="isVisible" queryData="SysUnitsViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="EXCLUSIVE_NUM" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="MEASURE_UNIT_CODE" :label="$t('getapi[3261]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="MEASURE_UNIT_NAME" :label="$t('getapi[3262]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Description" :label="$t('getapi[3263]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[143]')" width="100px"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
					<el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6851]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[6049]')" @onConfirm="del(scope)">
						<el-button slot="reference" type="text" size="small">{{$t('getapi[40]')}}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<!-- <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
			<el-tabs type="border-card">
				<el-tab-pane :label="$t('getapi[2020]')">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
						<el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none" />
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="intidata">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog> -->
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[6852]')" width="35%" :close-on-click-modal="false">
			<!-- <el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="120px" label-position="left" size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3261]')"><el-input v-model="formInline._measure_unit_code"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3262]')"><el-input v-model="formInline._measure_unit_name"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3263]')"><el-input v-model="formInline._description"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[143]')"><el-input v-model="formInline._remark"></el-input></el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row> -->
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3261]')}}</td>
					<td><el-input v-model="formInline._measure_unit_code" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[3262]')}}</td>
					<td><el-input v-model="formInline._measure_unit_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3263]')}}</td>
					<td><el-input v-model="formInline._description" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="formInline._remark" type="text" size="mini"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="sava">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'uni',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				_remark: '',
				_measure_unit_code: '',
				_description: '',
				_measure_unit_name: '',
				_delete_flag: false,
				_exclusive_num: 0
			},
			ids: '',
			cgzb: [],
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('uni'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: '', // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true, // 是否新增
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		this.getqwlist();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[888]"),this.$t("getapi[11]"));
        },
		//type
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			if (that.selectIDData.length > 0) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
				}
			} else {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
				}
			}
			// that.$limits.authority('plv2', 78, 1)
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('uni',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].EXCLUSIVE_NUM + ',';
			}
			console.log(that.selectIDData);
			that.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: 1,
				PageSize: 100000,
				Param: datac
			};
			that.$http.urlpost('Basic/General/GetUnitList', data, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
				that.loading = false;
			});
		},
		sava() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			parm.push(that.formInline);
			that.$http.urlpost('Basic/General/SaveUnit', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[3153]'));//'保存成功'
					that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
			});
		},
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('Basic/General/DeleteUnitByID', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));//'删除成功'
					that.intidata();
					/*that.datajson.forEach(function(item, index) {
						if (that.ids.indexOf(item.EXCLUSIVE_NUM) >= 0) {
							that.datajson.splice(index, 1);
						}
					});*/
				}
			});
		},
		// 获取查询条件
		getqwlist() {
			// let that = this;
			// that.$http.urlpost('Sch/PParts/QWList', {}, function(res) {
			// 	that.queryData = res.DataContent;
			// });
		},
		// 编辑
		edit(jsd) {
			console.log(jsd);
			this.formInline._description = jsd.row.Description;
			this.formInline._measure_unit_name = jsd.row.MEASURE_UNIT_NAME;
			this.formInline._measure_unit_code = jsd.row.MEASURE_UNIT_CODE;
			this.formInline._remark = jsd.row.REMARK;
			this.formInline._exclusive_num = jsd.row.EXCLUSIVE_NUM;
			this.editvisi = true;
		},
		// 删除
		del(jsd) {
			console.log(jsd);
			this.ids = jsd.row.EXCLUSIVE_NUM + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			let that = this;
			that.editvisi = true;
			that.formInline = {
				_remark: '',
				_measure_unit_code: '',
				_description: '',
				_measure_unit_name: '',
				_delete_flag: false,
				_exclusive_num: 0
			};
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'SysUnitsViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.pageIndex = 1;
			this.confirmGetView();
		},
		confirmGetView() {
			let that = this;
			that.pageIndex = 1
			that.isVisible = false;
			that.intidata();
		},
		//导出·
		exp() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: 1,
				PageSize: 100000,
				Param: datac,
				LangType:that.$processdata.getLang(),
                fromname: that.$t('getapi[888]')
			};
			that.$http.urlpost('Basic/General/UnitExportToExecl', data, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		}
	}
};
</script>

<style scoped lang="scss">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
